import { css } from "@emotion/react";
import { Box } from "InnoUI/components";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  .MuiButtonBase-root {
    color: black !important;
  }
`;

const ActivityBox = styled(Box)`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  max-height: 200px;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  globalStyles,
  ActivityBox,
};

export default SC;
